export default __webpack_public_path__ + "static/media/Organization.2e23036e.png";